import { Locale } from '@doordash/lib-i18n'
import { getIsLocale } from './lib'

type LocaleDefinition = {
  name: string
  value: Locale
}

export type SupportedLocales = Partial<Record<Locale, LocaleDefinition>>

const supportedLocales: SupportedLocales = {
  [Locale.EN_US]: {
    name: 'English (US)',
    value: Locale.EN_US,
  },
  [Locale.EN_AU]: {
    name: 'English (Australia)',
    value: Locale.EN_AU,
  },
  [Locale.EN_CA]: {
    name: 'English (Canada)',
    value: Locale.EN_CA,
  },
  [Locale.CA_FR]: {
    name: 'Français',
    value: Locale.FR_CA,
  },
  [Locale.ES_US]: {
    name: 'Español',
    value: Locale.ES_US,
  },
  [Locale.JA_JP]: {
    name: '日本語',
    value: Locale.JA_JP,
  },
  [Locale.DE_DE]: {
    name: 'Deutsch (Deutschland)',
    value: Locale.DE_DE,
  },
  [Locale.EN_NZ]: {
    name: 'English (New Zealand)',
    value: Locale.EN_NZ,
  },
}

export const supportedLocalesForNewSignup: SupportedLocales = {
  [Locale.EN_US]: {
    name: 'English (US)',
    value: Locale.EN_US,
  },
  [Locale.EN_AU]: {
    name: 'English (Australia)',
    value: Locale.EN_AU,
  },
  [Locale.EN_CA]: {
    name: 'English (Canada)',
    value: Locale.EN_CA,
  },
  [Locale.CA_FR]: {
    name: 'Français',
    value: Locale.FR_CA,
  },
  [Locale.ES_US]: {
    name: 'Español',
    value: Locale.ES_US,
  },
  [Locale.DE_DE]: {
    name: 'Deutsch (Deutschland)',
    value: Locale.DE_DE,
  },
  [Locale.DE_DE]: {
    name: 'Deutsch (Deutschland)',
    value: Locale.DE_DE,
  },
  [Locale.EN_NZ]: {
    name: 'English (New Zealand)',
    value: Locale.EN_NZ,
  },
}

export const defaultLocale = supportedLocales[Locale.EN_US].value

export const getIsSupportedLocale = (maybeLocale: string): boolean =>
  getIsLocale(maybeLocale) && Boolean(supportedLocales[maybeLocale])

export default supportedLocales
